import React from 'react';
import HeroSection from './components/HeroSection';
import SocialBar from './components/SocialBar';
import NavBar from './components/NavBar';
import AboutPage from './components/AboutPage';
import CommunityPage from './components/CommunityPage';
import CastPage from './components/CastPage';
import SparksBackground from './components/SparksBackground';
import Footer from './components/Footer';
import { SpeedInsights } from "@vercel/speed-insights/react"

import './index.css';  // Make sure this import is present


{/* <style>{`
        @keyframes spark {
          0% { 
            transform: translate(0, 0) scale(0);
            opacity: 0;
          }
          50% { 
            transform: translate(${Math.random() * 100 - 50}px, ${Math.random() * 100 - 50}px) scale(1);
            opacity: 0.8;
          }
          100% { 
            transform: translate(${Math.random() * 200 - 100}px, ${Math.random() * 200 - 100}px) scale(0);
            opacity: 0;
          }
        }
      `}</style>
      <div className="absolute inset-0 pointer-events-none">
        {sparks}
      </div> */}
      
const App = () => {
  
  return (
    <>
    <div className="min-h-screen bg-black text-white">
      <NavBar />
      <HeroSection id="hero" />
      <AboutPage id="about" />
      <SocialBar id="socials" />
      <CastPage id="cast-page" />
      <CommunityPage id="community" />
      <Footer />
    </div>
    <SpeedInsights />
    </>

  );
};

export default App;